/* eslint-disable react-hooks/rules-of-hooks */
import { useContext } from 'react'
import { UploadContext } from '../context/uploadContext'

export const useUploadFiles = () => useContext(UploadContext)
